<!-- My Account -->
<div class="row">
    <div class="col-md-4 mb-4">
        
        <div class="profile-nav" routerLink="profile">

            <div class="profile-nav-icon bg-main-color text-white p-4 rounded h1 text-center">
                <i class="fas fa-user"></i>
            </div>
            <h3 class="text-center text-uppercase text-main-color">my personal</h3>
        </div>
        
    </div>
    <div class="col-md-4 mb-4">
        
        <div class="profile-nav" routerLink="../favourite">

            <div class="profile-nav-icon bg-main-color text-white p-4 rounded h1 text-center">
                <i class="fas fa-heart"></i>
            </div>
            <h3 class="text-center text-uppercase text-main-color" >my favourite</h3>
        </div>
        
    </div>
    <div class="col-md-4 mb-4">
        
        <div class="profile-nav" routerLink="../orders/current">

            <div class="profile-nav-icon bg-main-color text-white p-4 rounded h1 text-center">
                <i class="fas fa-exchange-alt"></i>
            </div>
            <h3 class="text-center text-uppercase text-main-color">my requests</h3>
        </div>
        
    </div>
    <div class="col-md-4 mb-4">
        
        <div class="profile-nav" routerLink='../about'>

            <div class="profile-nav-icon bg-main-color text-white p-4 rounded h1 text-center">
                <i class="fas fa-mobile-alt"></i>
            </div>
            <h3 class="text-center text-uppercase text-main-color">about app</h3>
        </div>
        
    </div>
    <div class="col-md-4 mb-4">
        
        <div class="profile-nav" routerLink='../callus'>

            <div class="profile-nav-icon bg-main-color text-white p-4 rounded h1 text-center">
                <i class="fas fa-phone"></i>
            </div>
            <h3 class="text-center text-uppercase text-main-color">call us</h3>
        </div>
        
    </div>
    <div class="col-md-4 mb-4">
        
        <div class="profile-nav" routerLink='../cart' >

            <div class="profile-nav-icon bg-main-color text-white p-4 rounded h1 text-center">
                <i class="fas fa-shopping-cart"></i>
            </div>
            <h3 class="text-center text-uppercase text-main-color">my cart</h3>
        </div>
        
    </div>
    <div class="col-md-4 mb-4">
        
        <div class="profile-nav" routerLink='setting'>

            <div class="profile-nav-icon bg-main-color text-white p-4 rounded h1 text-center">
                <i class="fas fa-cog"></i>
            </div>
            <h3 class="text-center text-uppercase text-main-color">my settings</h3>
        </div>
        
    </div>
    <div class="col-md-4 mb-4">
        
        <div class="profile-nav" (click)="logout()">

            <div class="profile-nav-icon bg-main-color text-white p-4 rounded h1 text-center">
                <i class="fas fa-sign-out-alt"></i>
            </div>
            <h3 class="text-center text-uppercase text-main-color">logout</h3>
        </div>
        
    </div>
</div>
<!-- ./My Account -->